export let Scenes = {}

export function resetScenes() {
  Scenes = {}
}
